import React, { useState, useEffect } from 'react';
import { getGameLevels } from './services/gameLevelsService';

const LevelsList = ({ onLevelSelect, currentLevelIndex }) => {
    const levels = getGameLevels();
  
    useEffect(() => {
      // Automatically select the first level if none is selected
      if (currentLevelIndex === null && levels.length > 0) {
        onLevelSelect(0);
      }
    }, [currentLevelIndex, levels, onLevelSelect]);
  
    const [filter, setFilter] = useState('');
  
    const filteredLevels = levels.filter(level =>
      level.name.toLowerCase().includes(filter.toLowerCase())
    );

    return (
      <div className="p-4">
        <h3 className="text-2xl font-bold text-indigo-400 mb-4">Select Level</h3>
        <input
          type="text"
          placeholder="Filter levels..."
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className="mb-4 w-full px-4 py-2 rounded-lg border border-gray-500 focus:outline-none focus:ring-2 focus:ring-purple-500 text-black"
        />
        <ul
          className="space-y-3 overflow-y-auto"
          style={{ maxHeight: '400px' }} // Adjust height as needed
        >
          {filteredLevels.map((level, index) => (
            <li key={level.id}>
              <button
                onClick={() => onLevelSelect(index)}
                className={`w-full text-left px-4 py-2 rounded-lg transition duration-200 ease-in-out ${
                  index === currentLevelIndex
                    ? 'bg-purple-600 text-white shadow-md'
                    : 'bg-gray-700 hover:bg-gray-600 text-gray-200'
                } focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-75`}
              >
                {level.name}
              </button>
            </li>
          ))}
        </ul>
      </div>
    );
  };
  
  export default LevelsList;